/* jslint esversion: 6 */
/**
 * Favicon Badge
 *
 * Display a favicon badge on non-live environments to help differentiate tabs.
 *
 * @link http://lab.ejci.net/favico.js/
 */
const hosts = require('../../../gulpfile.js/config.js').hosts;
const Favico = require('favico.js');

function init() {

	const host  = window.location.host;
	const live  = hosts.live  ? hosts.live  : 'www.example.com';
	const test  = hosts.test  ? hosts.test  : 'test.example.com';
	const dev   = hosts.dev   ? hosts.dev   : 'dev.example.com';
	const local = hosts.local ? hosts.local : 'example.colab:8888';
	const sync  = hosts.sync  ? hosts.sync  : 'example.colab:3000';
	const xip   = hosts.xip   ? hosts.xip   : 'example.colab.192.168.1.1.xip.io:8888';

	if (host !== live) {
		const favico = new Favico({
			animation  : 'none',      // slide, fade, pop, popFade, none
			position   : 'down',      // down, left, up, upleft
			type       : 'rectangle', // circle, rectangle
			bgColor    : '#c00',      // #dc0000
			textColor  : '#fff',      // #ffffff
			fontFamily : 'mono',      // serif, sans-serif, mono, Arial, Verdana, ...
			fontStyle  : 'normal',    // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
		});

		switch (host) {
			case test  : favico.badge('T'); break;
			case dev   : favico.badge('D'); break;
			case local : favico.badge('L'); break;
			case sync  : favico.badge('S'); break;
			case xip   : favico.badge('X'); break;
			default : break;
		}
	}
}

export {init as default};
